import type { WorkItem } from "../types/work";

export const worksItems: WorkItem[] = [
  /*情報更新時は上段に追加すること*/
  {
    title: "牌買FIGHT!!",
    image: "assets/works/works_zeroichifight.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#ブース型", color: "var(--green)" },
    ],
    description: `牌を使って、アイテムを買って、FIGHT!!!!<br>これはあなたが牌やアイテムを駆使して謎を解く、ブース型謎解きイベントです。`,
    hashtag: "ゼロイチファイト",
    period: "2026/10/12",
  },
  {
    title: "Choose Day!!",
    image: "assets/works/works_chooseday.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#WEB型", color: "var(--green)" },
    ],
    description: `日付を選んで謎を解け！<br>手軽に遊べる、WEB謎解きゲーム第二弾。<br>謎解き初心者からお楽しみいただけます。`,
    hashtag: "ゼロイチチューズデイ",
    period: "2026/9/18",
    officialUrl: "https://chooseday.zeroichinazo.com/",
    officialUrlLabel: "ここからプレイ ＞",
  },
  {
    title: "幻の町と遺された手紙",
    image: "assets/works/works_kusadosengen.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#周遊型", color: "var(--green)" },
    ],
    description: `舞台は700年前に栄えた港町「草戸千軒」<br>広島県立歴史博物館様にて開催される、周遊型謎解きイベントです。<br>ゼロイチが謎制作を担当いたしました。`,
    hashtag: "草戸千軒ナイトミュージアム",
    period: "2026/9/18",
    officialUrl: "https://tv.rcc.jp/2026/nigth-museum/",
    officialUrlLabel: "公式サイトへ ＞",
  },
  {
    title: "1000億ローゼを盗み出せ！",
    image: "assets/works/works_senoku.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#ルーム型", color: "var(--green)" },
    ],
    description: `凄腕エージェントとなり、短時間で可能な限り金を盗め！<br>果たして、あなたはいくら盗み出せるだろうか？`,
    hashtag: "ゼロイチセンオク",
    period: "2026/7/4",
  },
  {
    title: "未完の駄洒落旅",
    image: "assets/works/works_dajaretabi.png",
    tags: [
      { label: "#言葉遊び", color: "var(--green)" },
      { label: "#周遊型", color: "var(--green)" },
    ],
    description: `Q.ダジャレを完成させろ<br>これはあなたが未完のダジャレを完成させていく、体験型言葉遊びイベントです。`,
    hashtag: "ゼロイチダジャレタビ",
    period: "2026/6/20",
  },
  {
    title: "J0001N US!",
    image: "assets/works/works_joinus.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#ホール型", color: "var(--green)" },
    ],
    description: `ゼロイチ1周年を記念した謎解きイベント。<br>──ともに遊ぼう。ともに祝おう。`,
    hashtag: "ゼロイチジョイナス",
    period: "2026/6/20",
  },
  {
    title: "MAGICAL BATH POWDER",
    image: "assets/works/works_magicalbathpowder.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#キット型", color: "var(--green)" },
    ],
    description: `株式会社タカラッシュ様から発売された、実物の入浴剤がついた謎解きグッズです。<br>ゼロイチが謎制作を担当いたしました。<br>※NANICA名古屋限定販売`,
    hashtag: "入浴剤謎",
    period: "2026/5/23",
  },
  {
    title: "100円なぞみくじ",
    image: "assets/works/works_100ennazomikuji.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#キット型", color: "var(--green)" },
    ],
    description: `実際におみくじを引き、運勢を占おう！<br>ただし、結果は謎を解かないと分からない…！？<br>※おみくじは全5種類`,
    hashtag: "ゼロイチナゾミクジ",
    period: "2026/5/23",
  },
  {
    title: "Which 0001?",
    image: "assets/works/works_which0001.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#WEB型", color: "var(--green)" },
    ],
    description: `0か1かを選べ！<br>手軽に遊べるWEB謎解きゲーム。<br>謎解き初心者からお楽しみいただけます。`,
    hashtag: "ゼロイチウィッチワン",
    period: "2026/5/12",
    officialUrl: "https://which0001.zeroichinazo.com/",
    officialUrlLabel: "ここからプレイ ＞",
  },
  {
    title: "ひらめき銭湯『解乃湯』",
    image: "assets/works/works_tokinoyu.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#カフェ型", color: "var(--green)" },
    ],
    description: `「頭をほぐしにいらっしゃい──」<br>あなたが訪れたのは、頭をほぐすひらめき銭湯『解乃湯』<br>アイテムを駆使し、この不思議な銭湯の謎を解き明かそう！`,
    hashtag: "ゼロイチトキノユ",
    period: "2026/2/21",
  },
  {
    title: "トニナルコトバルーム",
    image: "assets/works/works_toninarukotobaroom.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#ブース型", color: "var(--green)" },
    ],
    description: `ボードゲーム『トニナルコトバ』が謎解きゲームに！<br>目の前のアイテムを駆使して、「○○と△△になる」のお題に当てはまるコトバを答えよう！`,
    hashtag: "トニナルコトバルーム",
    period: "2025/12/20",
  },
  {
    title: "八回廻し",
    image: "assets/works/works_hachikaimawashi.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#キット型", color: "var(--green)" },
    ],
    description: `自宅で遊べる謎解きグッズ②<br>あるものを「八回使い廻して」謎を解こう！<br>謎解き初心者からお楽しみいただけます。`,
    hashtag: "ゼロイチハチカイ",
    period: "2025/11/8",
    officialUrl: "https://zeroichigoods.booth.pm/items/7701296",
    officialUrlLabel: "購入はこちら ＞",
  },
  {
    title: "トニナルコトバ",
    image: "assets/works/works_toninarukotoba.png",
    tags: [{ label: "#ボードゲーム", color: "var(--green)" }],
    description: `｢瞬発力｣と｢語彙力｣ がカギ！？<br>「〇〇と△△になる」のお題に当てはまるコトバをいち早く答えよう！`,
    hashtag: "ゼロイチトニナルコトバ",
    period: "2025/10/11",
    officialUrl: "https://toninarukotoba.zeroichinazo.com/",
    officialUrlLabel: "WEBで体験 ＞",
  },
  {
    title: "START!!",
    image: "assets/works/works_start.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#キット型", color: "var(--green)" },
    ],
    description: `自宅で遊べる謎解きグッズ①<br>謎解き沼への第一歩目を目指して制作しました。<br>謎解き初心者からお楽しみいただけます。`,
    hashtag: "ゼロイチスタート",
    period: "2025/10/11",
    officialUrl: "https://zeroichigoods.booth.pm/items/7701193",
    officialUrlLabel: "購入はこちら ＞",
  },
  {
    title: "パシャリドル",
    image: "assets/works/works_pashariddle.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#ルーム型", color: "var(--green)" },
    ],
    description: `「ナゾの答えをパシャリと撮ろう！」<br>これはあなたのスマートフォンで写真を撮り、<br>謎解きにチャレンジするゲームイベントです。`,
    hashtag: "ゼロイチパシャリドル",
    period: "2025/7/19",
  },
  {
    title: "関西ひとつなぎの謎",
    image: "assets/works/works_hitotunagi.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#周遊型", color: "var(--green)" },
    ],
    description: `株式会社フラップゼロアルファ様が主催する、関西10鉄道とコラボした超大型プロジェクト。プロジェクト内の全ての謎を制作しました。`,
    hashtag: "関西ひとつなぎの謎",
    period: "2025/3/19",
    officialUrl: "https://nazotoki-zepets.com/10piece-nazo-2025/",
    officialUrlLabel: "公式サイトへ ＞",
  },
  {
    title: "桜川謎解き街ガイド",
    image: "assets/works/works_sakuragawanazo.png",
    tags: [
      { label: "#謎解き", color: "var(--green)" },
      { label: "#周遊型", color: "var(--green)" },
    ],
    description: `大阪最宴祭13運営コンテンツの1つ。<br>桜川を散策する、王道の周遊型謎解きです。<br>※現在は販売を停止しております。`,
    hashtag: "桜川謎解き街ガイド",
    period: "2024/9/21",
    officialUrl: "https://www.sakuragawanazo.com",
    officialUrlLabel: "公式サイトへ ＞",
  },
];
